// extracted by mini-css-extract-plugin
export default {"loader":"styles-module--loader--8837a","spin":"styles-module--spin--19c73"};